<template>
  <div>
    <div class="ready_banner">
      <p class="ready_banner_top">{{examPaperInfo.title}}</p>
      <div class="ready_banner_bottom">
        <p class="mb30">考试内容简介：{{examPaperInfo.description}}</p>
        <p>合格标准：满分{{examPaperInfo.score}}分，{{examPaperInfo.passline}}分及格</p>
        <p>考试时长：{{examPaperInfo.time}}分钟</p>
        <p>考题数量：{{examPaperInfo.cntQuestion}}题</p>
        <p>考试开放时间：{{examPaperInfo.startDate}}——{{examPaperInfo.endDate}}</p>
      </div>
      <a href="javascript:;" class="kaoshi_btn" @click="startExam(examPaperInfo)">开始考试</a>
    </div>
    <v-dialog/>
  </div>
</template>
<script>
  import rangePermission from '@/utils/rangePermission'
  import config from '@/config'
  export default {
    components: { },
    props: ['path'],
    data () {
      return {
        examPaperInfo: {},
        examFrom: this.$route.params.type,
        planItemId: this.$route.query.pid
      }
    },
    created () {
      this.getExamPaper(this.$route.params.id)
      /*rangePermission.checkScope({ // 防盗链
        itemId: this.$route.params.id,
        itemType: '01',
        permission: '02'
      }).then((r) => {
        if (!r.data) {
          let path = (process.env.NODE_ENV == 'development') ? 'http://localhost:8081' : config.domains[0] + ':' + config.webport
          window.location.href = path
        }
      })*/
    },
    mounted () {
      this.$nextTick(() => {
      })
    },
    computed: {},
    methods: {
      getExamPaper (id) {
        this.$api.post(this.$global.examApiPath, '/examPaper/searchByUser', {id: id}, r => {
          if (r.data) {
            this.examPaperInfo = r.data[0]
          }
        })
      },
      startExam (examPaperInfo) {
        if (this.$TOKEN_VAL && this.$TOKEN_VAL!='') {
          let state = this.$utils.judgmentState(examPaperInfo.startDate, examPaperInfo.endDate)
          if (state=='0') {
            let that = this
            if (examPaperInfo.examId && examPaperInfo.examId!='' && examPaperInfo.remainTime>0) {
              this.$modal.show('dialog', {
                title: '提示',
                text: '该考试存在未完成记录，是否继续？',
                buttons: [
                  {
                    title: '继续',
                    default: true,
                    handler: () => {
                      that.$modal.hide('dialog')
                      if (this.examFrom == '0') {
                        this.$router.push({path: this.path + '/examStart/' + examPaperInfo.id + '/' + examPaperInfo.examId})
                      } else if (this.examFrom == '1') {
                        that.$api.post(this.$global.bylApiPath, '/planUsers/saveExamId', {examId: examPaperInfo.examId, id: this.planItemId}, r => {
                          this.$router.push({path: this.path + '/examStart/' + examPaperInfo.id + '/' + examPaperInfo.examId})
                        })
                      }
                    }
                  },
                  {
                    title: '从新开始',
                    handler: () => {
                      this.$api.post(this.$global.examApiPath, '/examExamScore/getExamId', {paperId: examPaperInfo.id}, r => {
                        if (r.data) {
                          that.$modal.hide('dialog')
                          var examId = r.data
                          if (this.examFrom == '0') {
                            this.$router.push({path: this.path + '/examStart/' + examPaperInfo.id + '/' + examId})
                          } else if (this.examFrom == '1') {
                            that.$api.post(this.$global.bylApiPath, '/planUsers/saveExamId', {examId: r.data, id: this.planItemId}, r => {
                              this.$router.push({path: this.path + '/examStart/' + examPaperInfo.id + '/' + examId})
                            })
                          }
                        }
                      })
                    }
                  }
                ]
              })
            } else {
              this.$api.post(this.$global.examApiPath, '/examExamScore/getExamId', {paperId: examPaperInfo.id}, r => {
                if (r.data) {
                  var examId = r.data
                  if (this.examFrom == '0') { // 在线考试或直接分配考试
                    this.$router.push({path: this.path + '/examStart/' + examPaperInfo.id + '/' + examId})
                  } else if (this.examFrom == '1') {  // 计划培训考试
                    that.$api.post(this.$global.bylApiPath, '/planUsers/saveExamId', {examId: r.data, id: this.planItemId}, r => {
                      this.$router.push({path: this.path + '/examStart/' + examPaperInfo.id + '/' + examId})
                    })
                  }
                }
              })
            }
          } else if (state=='1') {
            this.$toasted.show('该考试已结束，无法进行考试！', {
              duration: 1000
            })
          } else if (state=='2') {
            this.$toasted.show('该考试未开放，无法进行考试！', {
              duration: 1000
            })
          } else if (state=='-1') {
            this.$toasted.show('该考试开始时间或结束时间有误，无法进行考试！', {
              duration: 1000
            })
          }
        } else {
          this.$toasted.show('请先登录！', {
            duration: 800
          })
        }
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/exam/ready.vue